module.exports = __webpack_public_path__ + "img/666.d2611066.png";